// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ShippingPolicyComponent } from './shipping-policy/shipping-policy.component';
import { PoliciesRoutingModule } from './policies-routing.module';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { RefundPolicyComponent } from './refund-policy/refund-policy.component';

@NgModule({
  imports: [
    CommonModule,
    PoliciesRoutingModule,
    PrivacyPolicyComponent,
    ShippingPolicyComponent,
    TermsOfServiceComponent,
    RefundPolicyComponent
  ]
})
export class PoliciesModule {
}
